import { gql } from '@apollo/client';
import { CAMPAIGN_FRAGMENT } from '../fragments/campaign.newsletter.graphql';

export const DELETE_CAMPAIGN_MUTATION = gql`
  mutation DeleteCampaign($where: CampaignWhereUniqueInput!) {
    deleteCampaign(where: $where) {
      ...Campaign
    }
  }
  ${CAMPAIGN_FRAGMENT}
`;
